import happySleepLogo from 'images/partners/happy-sleep.svg';

export type Partner = {
  id: string;
  name: string;
  logo: string;
};

const PARTNERS: Record<string, Partner> = {
  happy_sleep: {
    id: 'happy_sleep',
    name: 'Happy Sleep',
    logo: happySleepLogo,
  },
};

export function getPartnerForCode(rawCode: string | null | undefined): Partner | null {
  if (!rawCode) return null;
  const normalized = rawCode.trim().toLowerCase();
  if (!normalized) return null;
  return PARTNERS[normalized] ?? null;
}
